<script>
  import { _ } from 'svelte-i18n'
  import {business_monthly_price_details, business_yearly_price_details, business_monthly_sale_details, business_yearly_sale_details, currency_sale } from '../stores'
  import { getCurrencySymbol } from '../modules/visitorCountry'
  import HorizontalOptionsList from '../elements/HorizontalOptionsList.svelte';

  let plans = [
    {value:'yearly', display:'Pay yearly, save 25%'},
    {value:'monthly', display:'Pay monthly'}
  ]
  export let selected_plan = 'yearly'

  let displayed_price
  let displayed_monthly_price
  let displayed_sale_price
  let displayed_discount_amount
  let displayed_discount_percent

  $: yearly_sale_exists = !!$business_yearly_sale_details
  $: monthly_sale_exists = !!$business_monthly_sale_details
  $: sale_exists = yearly_sale_exists || monthly_sale_exists
  
  // get the currency symbol from the last character of the yearly price_details.display
  $: currency = $business_yearly_price_details?.currency || "USD"
  $: currency_symbol = getCurrencySymbol(currency)
  
  $: monthly_price = $business_monthly_price_details?.price || 8
  $: monthly_sale_price = Math.floor($business_monthly_sale_details?.unitPrice)
  $: monthly_discount_amount = Math.ceil($business_monthly_sale_details?.discountValue)
  $: monthly_discount_percent = Math.ceil($business_monthly_sale_details?.discountPercent)

  $: yearly_price = $business_yearly_price_details?.price || 72
  $: yearly_sale_price = Math.floor($business_yearly_sale_details?.unitPrice*100)/100
  $: yearly_monthly_display_price = yearly_sale_exists ? Math.floor(yearly_sale_price/12*100)/100 : Math.floor(yearly_price/12*100)/100
  $: yearly_discount_amount = Math.floor($business_yearly_sale_details?.discountValue)
  $: yearly_discount_percent = Math.round($business_yearly_sale_details?.discountPercent)

  $: if (selected_plan === 'yearly') {
    displayed_price = yearly_price
    displayed_monthly_price = yearly_monthly_display_price
    displayed_sale_price = yearly_sale_price
    displayed_discount_amount = yearly_discount_amount
    displayed_discount_percent = yearly_discount_percent
  } else {
    displayed_price = monthly_price
    displayed_monthly_price = monthly_price
    displayed_sale_price = monthly_sale_price
    displayed_discount_amount = monthly_discount_amount
    displayed_discount_percent = monthly_discount_percent
  }

</script>

<div>
  <div class="selector">
    <HorizontalOptionsList pill_shaped={true} small={true} list_options={plans} bind:selected_option={selected_plan}/>
  </div>

  <h2 
    class:sale={yearly_sale_exists && selected_plan === 'yearly' || monthly_sale_exists && selected_plan === 'monthly' } 
    data-sale-text={sale_exists ? `${displayed_discount_percent}% ${$_('subscriptionPlan.sale')}` : ""}
    >
    {currency_symbol}{displayed_monthly_price}/month
  </h2>
  <p>
    Billed {selected_plan}, 
    {#if selected_plan === 'yearly'}
      {#if $currency_sale}
        <span class="lined">72 USD</span> {displayed_price} {currency} for 12 months
        <br>
        <span class="discount">
          Reduced price based on the purchasing power of your currency
        </span>
      {:else if yearly_sale_exists}
        <span class="lined">{displayed_price} {currency}</span> {displayed_sale_price} {currency}
      {:else}
        {displayed_price} {currency} for 12 months
      {/if}
    {/if}
    {#if selected_plan === 'monthly'}
      {#if monthly_sale_exists}
        <span class="lined">{displayed_price} {currency}</span> {displayed_sale_price} {currency}
      {:else}
        {displayed_price} {currency}
      {/if}
      / month
    {/if}
  </p>

</div>

<style>
  div {
    font-variant-numeric: lining-nums;
  }
  .selector {
    display: inline-block;
    position: relative;
    z-index: 1;
    margin-bottom: 0;
    padding: 0 0.5rem;
    transform: translate(6.5%, 40%);
  }
  h2 {
    position: relative;
    padding: 3rem 0.75rem 0;
    border: 1px solid var(--c-pill-bg);
    border-bottom: none;
    text-align: center;
    font-size: 3rem;
    font-family: var(--PensumSans-Bold);
  }

  p {
    padding: 1rem 1.5rem 1.5rem;
    border-left: 1px solid var(--c-pill-bg);
    border-right: 1px solid var(--c-pill-bg);
    text-align: center;
  }
 
  /* Sale */
  .lined {
    text-decoration: line-through;
  }

  .sale {
    color: var(--c-danger);
  }
  .discount {
    color: var(--c-accent-orange);
  }


</style>